// React
import React from 'react'

// Next
import Head from 'next/head'
import { useRouter } from 'next/router'
import { GetStaticProps } from 'next'

// Components
import Search from '@/components/memes/image-search'

// Utils
import { useSession } from '@/utils/auth/user-context'
import { getLandingStaticProps } from '@/utils/ui/landing/get-static-props'

// External
import { useTranslation } from 'next-i18next'

const SearchPage: React.FC = () => {
  const { t } = useTranslation('routes/search')
  const session = useSession()
  const router = useRouter()
  const { query } = router.query
  return (
    <>
      <Head>
        <title>{t('meta.title')}</title>
        <meta name='description' content={t('meta.description')} />
        <meta property='og:url' content='https://supermeme.ai/search' />
        <link rel='canonical' href='https://supermeme.ai/search' />
      </Head>
      <>
        <Search
          session={session}
          showEditButton={true}
          initialQuery={query as string}
          pushQueryToUrl={true}
        />
      </>
    </>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return getLandingStaticProps({
    locale,
    namespaces: [
      'common',
      'routes/search',
      'components/image-search',
      'components/login-form',
      'components/raw-meme-template',
    ],
  })
}

export default SearchPage
